import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

export const CustomSelect = ({ options, value, onChange, label = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (val) => {
    onChange(val);
    setIsOpen(false);
  };

  const currentLabel = options.find(o => o.value === value)?.label || value;

  return (
    <div className="custom-select-container" ref={dropdownRef}>
      {label && <span className="custom-select-label">{label}</span>}
      
      <div className={`custom-select-trigger ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)}>
        <span>{currentLabel}</span>
        <ChevronDown size={14} className={`arrow-icon ${isOpen ? 'rotated' : ''}`} />
      </div>

      <div className={`custom-options ${isOpen ? 'show' : ''}`}>
        {options.map((opt) => (
          <div 
            key={opt.value} 
            className={`custom-option ${value === opt.value ? 'selected' : ''}`}
            onClick={() => handleSelect(opt.value)}
          >
            {opt.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export const QuantitySelector = ({ quantity, setQuantity }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="qty-selector" ref={ref}>
      <div className="qty-trigger" onClick={() => setIsOpen(!isOpen)}>
        {quantity}
        <ChevronDown size={14} className={`arrow-icon ${isOpen ? 'rotated' : ''}`} />
      </div>
      
      {/* REMOVED {isOpen && ...} condition. Now uses CSS class 'show' */}
      <div className={`qty-dropdown ${isOpen ? 'show' : ''}`}>
        {[...Array(10)].map((_, i) => (
          <div 
            key={i} 
            className="qty-option" 
            onClick={() => { setQuantity(i + 1); setIsOpen(false); }}
          >
            {i + 1}
          </div>
        ))}
      </div>
    </div>
  );
};